import React from 'react';
import PropTypes from 'prop-types';
import AccordionManager from './AccordionManager';
import AccordionView from './AccordionView';
import { Item } from './Item';




const Accordion = ({
  allowMultiple,
  autoScroll,
  children,
  contextRef,
  initiallyExpanded,
  items,
  onToggle,
  theme,
  ...rest
}) => <AccordionManager
    allowMultiple={allowMultiple}
    initiallyExpanded={initiallyExpanded}
    onToggle={onToggle}
  >
    <AccordionView
      allowMultiple={allowMultiple}
      autoScroll={autoScroll}
      contextRef={contextRef}
      items={items}
      theme={theme}
      {...rest}
    >
      {children}
    </AccordionView>
  </AccordionManager>

Accordion.Item = Item;

export default Accordion;

Accordion.propTypes = {
  allowMultiple: PropTypes.bool,
  autoScroll: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  contextRef: PropTypes.func,
  initiallyExpanded: PropTypes.arrayOf(PropTypes.string),
  items: PropTypes.arrayOf(PropTypes.shape({})),
  onToggle: PropTypes.func,
  theme: PropTypes.oneOf(['light', 'dark']),
};

Accordion.defaultProps = {
  allowMultiple: false,
  autoScroll: true,
  initiallyExpanded: [],
  items: [],
  theme: 'light',
};
